// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"E0-z"};